/**
 * The issue filters that are not status.
 *
 * Status is navigation and lives on the page with its counts; everything here
 * refines a view the user has already chosen. See [[issues-page.spec]].
 *
 * These live in `lib` rather than beside one surface because two surfaces now
 * render them: [[issue-filter-drawer.spec]] on mobile and
 * [[issue-filter-sidebar.spec]] on desktop.
 */
export interface IssueRefinementFilters {
  /** User id, or null for "anyone". */
  assignedTo: string | null;
  /** User id of the raiser, or null for "anyone". */
  createdBy: string | null;
  overdue: boolean;
  search: string;
}

export const EMPTY_ISSUE_FILTERS: IssueRefinementFilters = {
  assignedTo: null,
  createdBy: null,
  overdue: false,
  search: "",
};

/** How many filters are applied, for the badge on the filter button. */
export function activeFilterCount(filters: IssueRefinementFilters): number {
  let count = 0;
  if (filters.assignedTo) count += 1;
  if (filters.createdBy) count += 1;
  if (filters.overdue) count += 1;
  if (filters.search.trim()) count += 1;
  return count;
}
